import React from 'react';

import {FooterPolicyPrivacyContact} from '../PolicyPrivacyTexts/FooterPolicyPrivacyContact';
import {InitialTextPrivacyPolicy} from '../PolicyPrivacyTexts/InitialTextPrivacyPolicy';
import {TextAdditionalControls} from '../PolicyPrivacyTexts/TextAdditionalControls';
import {TextDataSharing} from '../PolicyPrivacyTexts/TextDataSharing';
import {TextGetInTouch} from '../PolicyPrivacyTexts/TextGetInTouch';
import {TextInteractionsThirdParties} from '../PolicyPrivacyTexts/TextInteractionsThirdParties';
import {TextInternationalDataTransfer} from '../PolicyPrivacyTexts/TextInternationalDataTransfer';
import {TextPersonalData} from '../PolicyPrivacyTexts/TextPersonalData';
import {TextRightsHolderPersonalData} from '../PolicyPrivacyTexts/TextRightsHolderPersonalData';
import {TextTerminationProcessing} from '../PolicyPrivacyTexts/TextTerminationProcessing';
import {TextWhatDataCollect} from '../PolicyPrivacyTexts/TextWhatDataCollect';

import './PolicyPrivacy.style.scss';

export const PolicyPrivacy = () => {
  return (
    <section className="policy" data-testid="policy-privacy-modal">
      <header className="policy__header">
        <h2 className="policy__title">POLÍTICA DE PRIVACIDADE</h2>
      </header>

      <article className="policy__article">
        <InitialTextPrivacyPolicy />
        <TextWhatDataCollect />
        <TextPersonalData />
        <TextDataSharing />
        <TextInternationalDataTransfer />
        <TextInteractionsThirdParties />
        <TextRightsHolderPersonalData />
        <TextAdditionalControls />
        <TextTerminationProcessing />
        <TextGetInTouch />
        <FooterPolicyPrivacyContact />
      </article>
    </section>
  );
};
